/* ============================================================================
   Sixth Man - Archive: click a design to see the back, click again to return.

   Replaces the earlier press-and-hold. Hold was a poor fit here: it has no
   affordance, it fights the browser's own long-press menu, and it makes you
   keep a finger down to look at something you are trying to study. A tap that
   flips and a tap that flips back is the obvious gesture and it survives on
   both mouse and touch.

   Desktop keeps hover as a preview - but a flipped item stays flipped when the
   cursor leaves, so a deliberate click always beats an incidental hover.

   Only items that actually HAVE a back image are made interactive. Nothing here
   promises a second view that does not exist - roughly a fifth of the archive
   is front-only.

   These are not links. The archive is view-only by design, so there is no
   navigation to interfere with and a click can safely mean "flip".
   ============================================================================ */
(function () {
  "use strict";

  var items = [].slice.call(document.querySelectorAll(".sm-archive__item.has-back"));
  if (!items.length) return;

  items.forEach(function (item) {
    // Make it a real control: reachable by keyboard and announced as pressable.
    item.setAttribute("tabindex", "0");
    item.setAttribute("role", "button");
    item.setAttribute("aria-pressed", "false");

    var name = item.querySelector(".sm-archive__name");
    if (name) {
      item.setAttribute("aria-label", name.textContent.trim() + " - show reverse");
    }

    function toggle() {
      var flipped = item.classList.toggle("is-flipped");
      item.setAttribute("aria-pressed", flipped ? "true" : "false");
    }

    item.addEventListener("click", toggle);

    item.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();   // stop Space scrolling the page
        toggle();
      }
    });

    // A long press on an image otherwise raises the save/copy sheet on iOS,
    // which lands on top of the very thing being looked at.
    item.addEventListener("contextmenu", function (e) { e.preventDefault(); });
  });
})();
